<template>
  <b-form-input
    :class="type == 'password' ? 'input-password-' : ''"
    :type="'text'"
    id="meu-input"
    :value="passwordValue"
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  props: ['value', 'type'],
  data() {
    return {
      passwordValue: this.value
    };
  },
  watch: {
    value(newVal) {
      this.passwordValue = newVal;
    }
  }
};
</script>

<style scoped>
.input-password- {
  -webkit-text-security: none;
  -webkit-text-security: circle;
  -webkit-text-security: square;
  -webkit-text-security: disc;
}
</style>
